export default __webpack_public_path__ + "static/media/select-approach.5e096152.png";